module.exports = __webpack_public_path__ + "static/media/kennon-thumbnailDT.45407a1c.jpg";